import { KeycloakConfig } from 'keycloak-js';

const keycloakDevConfig: KeycloakConfig = {
  url: 'https://keycloak-dso-dev.southeastasia.cloudapp.azure.com:8443',
  realm: 'DSODEV',
  clientId: 'DSOMyPurchaseE2E',
};

export default keycloakDevConfig;
